import { Col, Row, Image } from 'antd'
import styled from 'styled-components'

const WithAppWrapper = styled.div`
    width: 275px;   
    
    @media (max-width: 1440px) {    
        width: 275px !important;  
        /* padding: 30px; */
    } 
    @media (max-width: 480px) {    
        width: 900px !important;
        #mobile-withapp{
            width: 240px
        }  
    } 
`
export default function WithApp(props: { title: string, icon: string, description: string, image: string }) {
    return (
        <WithAppWrapper>
            <Col  >
                <Row justify="center" align="middle">
                    <Col >
                        <Image
                            style={{
                                width: "26px",
                                height: "26px"
                            }}
                            preview={false}
                            src={props.icon}
                        />
                    </Col>

                    <Col
                        style={{
                            paddingLeft: "10px",
                            fontSize: "26px",
                            color: "#31BD9C",
                            fontWeight: "bold"
                        }}>
                        {props.title}
                    </Col>
                </Row>

                <Row
                    justify="center"
                    style={{ color: "#747474", fontSize: "17px", fontWeight: "bold", paddingBottom: "17px" }}
                >
                    {props.description}
                </Row>

                <Row justify="center">
                    <Image
                        id="mobile-withapp"
                        preview={false}
                        src={props.image}
                    />
                </Row>
            </Col>
        </WithAppWrapper>
    )
}
